import React from 'react';
import { InView } from 'react-intersection-observer';

import useEventTracking from '@hooks/useEventTracking';
import { ImpressionElement, impression } from '@tracking';

import type { AnalyticsWrapperProps } from './interfaces';
import useAnalyticsWrapper from './useAnalyticsWrapper';

const AnalyticsWrapper = ({
  children,
  shouldTrackClick,
  shouldTrackImpression,
  trackingLocation,
}: AnalyticsWrapperProps) => {
  const { Track, trackEvent } = useEventTracking({
    ...(trackingLocation ? { location: trackingLocation } : {}),
  });
  useAnalyticsWrapper({ shouldTrackClick, trackEvent });

  return shouldTrackImpression ? (
    <InView
      triggerOnce={true}
      onChange={(inView) => {
        inView && trackEvent(impression({ impressionElement: ImpressionElement.PageTemplates }));
      }}
    >
      {children}
    </InView>
  ) : (
    <Track>{children}</Track>
  );
};

export default AnalyticsWrapper;
